import axiosInstance from "api/axiosInstance";

export const getQrCode = async ({ accessToken, username }) => {
  try {
    const response = await axiosInstance.get(
      `/business/@${encodeURIComponent(username)}/qr`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        responseType: "blob",
      }
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;

      if (status === 403) {
        console.warn(
          "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
        );

        window.location.href = "/login";
        return;
      }

      throw {
        statusCode: status,
        message:
          error.response.data?.message ||
          "خطای ناشناخته هنگام دریافت QR کد",
      };
    }

    throw {
      statusCode: 500,
      message: "مشکل شبکه یا عدم دسترسی به سرور",
    };
  }
};